import 'css-chunk:src/components/form-fields/text-area-component/text-area-component.module.scss';export default {
  "text-area-component": "text-area-component_text-area-component__biKTc",
  "disabled": "text-area-component_disabled__DhMdt",
  "help-text": "text-area-component_help-text__tj8LW",
  "max-characters": "text-area-component_max-characters__xO1hT",
  "text-area-container": "text-area-component_text-area-container__O2k8E",
  "text-area-wrapper": "text-area-component_text-area-wrapper__lQufa",
  "non-resizable": "text-area-component_non-resizable__hENCe",
  "text-area": "text-area-component_text-area__jpLP5",
  "resizable": "text-area-component_resizable__WRu0-",
  "resizer": "text-area-component_resizer__VfoEp",
  "white": "text-area-component_white__cuA-T",
  "grey": "text-area-component_grey__cm4-W",
  "error": "text-area-component_error__DhetK",
  "character-limit-container": "text-area-component_character-limit-container__aUrHl",
  "error-text": "text-area-component_error-text__37EOz"
};